import React, { PureComponent } from 'react';

import Select from 'components/cosmos/select';
import { translate } from 'components/translate';
import { UserService } from 'modules/user';
import PropTypes from 'prop-types';

import './SelectLanguages.scss';

@translate()
export default class SelectLanguages extends PureComponent {
  state = {
    selectedLang: null
  };

  static propTypes = {
    onSelectLang: PropTypes.func,
    languages: PropTypes.array,
    t: PropTypes.func,
    error: PropTypes.bool
  };

  static defaultProps = {
    languages: []
  };

  componentDidMount() {
    const userLanguage = UserService.language;

    if (userLanguage && this.props.languages.length) {
      const language = this.translatedLangs.find(
        (lang) => lang.value === userLanguage
      );

      language && this.setSelectedLang(language);
    }
  }

  get langOptions() {
    const translatedLangs = this.translatedLangs;
    const sortedLangs = this.sortedLangs(translatedLangs);

    return sortedLangs;
  }

  get translatedLangs() {
    const { languages, t } = this.props;

    return languages.map((lang) => ({
      value: lang,
      label: t(`supported_languages.${lang}`)
    }));
  }

  sortedLangs(langs = []) {
    return langs.sort((a, b) => a.label.localeCompare(b.label));
  }

  setSelectedLang(lang) {
    if (lang) {
      const { onSelectLang } = this.props;

      this.setState({ selectedLang: lang });
      onSelectLang && onSelectLang(lang.value);
    }
  }

  render() {
    const { t } = this.props;
    const { selectedLang } = this.state;

    return (
      <Select
        id="languages"
        className="mb__sm select-languages"
        onChange={this.setSelectedLang.bind(this)}
        options={this.langOptions}
        placeholder={t('player_subtitles.translate.search_langs')}
        value={selectedLang}
      />
    );
  }
}
